import React from 'react';
import FadeIn from '../ui/FadeIn';
import Button from '../ui/Button';

const FooterCTA = () => {
  const scrollToForm = () => {
    const element = document.getElementById('inquire');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#080806] py-20 px-6 border-t border-gold/10 text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/5 via-transparent to-transparent pointer-events-none"></div>
      
      <div className="relative z-10 max-w-2xl mx-auto">
        <FadeIn>
          <h2 className="font-serif text-[32px] md:text-5xl text-ivory mb-6 leading-tight">Experience October at Padua</h2>
          <p className="text-stone font-light mb-10 leading-relaxed text-lg">
            A prime Saturday date in the height of wedding season is a rare find. Ensure your story begins here.
          </p>
          
          <Button 
            variant="secondary" 
            onClick={scrollToForm} 
            className="w-full md:w-auto mb-16"
          >
            Request October 17 Availability
          </Button>
          
          <div className="w-px h-16 bg-gradient-to-b from-gold/40 to-transparent mx-auto mb-12"></div>
          
          <div className="flex flex-col items-center space-y-4 text-[12px] tracking-[0.3em] text-stone/60 uppercase">
            <a 
              href="https://paduaweddings.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-gold transition-colors"
            >
              PaduaWeddings.com
            </a>
            
            <div className="flex flex-col md:flex-row gap-2 md:gap-4 items-center">
              <a href="tel:9096241241" className="hover:text-gold transition-colors">
                909.624.1241
              </a>
              <span className="opacity-20 hidden md:inline">|</span>
              <a href="mailto:info@paduaweddings.com" className="hover:text-gold transition-colors lowercase tracking-normal">
                info@paduaweddings.com
              </a>
            </div>
            
            <p className="mt-8 opacity-30 font-light tracking-widest text-[10px]">
              &copy; {new Date().getFullYear()} PADUA HILLS ESTATE
            </p>
          </div>
        </FadeIn>
      </div>
    </footer>
  );
};

export default FooterCTA;